import { useContext } from 'react';

import { CockpitContextProviderContext } from './CockpitContextProvider.context.ts';

export const useCockpitContext = () => {
  const context = useContext(CockpitContextProviderContext);
  if (!context) {
    throw new Error('useCockpitContext must be used within a CockpitContextProvider');
  }
  return context;
};
